import { OfferStatus } from '@wwt/entities/api/search-response'

export const reservationStatuses = [
	OfferStatus.PAYMENT_PENDING,
	OfferStatus.PAYMENT_FAILED,
	OfferStatus.PAYMENT_PENDING,
	OfferStatus.RESERVATION_PENDING,
	OfferStatus.RESERVATION_FAILED,
	OfferStatus.RESERVED,
	OfferStatus.RESERVATION_CANCELLED,
	OfferStatus.RESERVATION_CANCEL_PENDING,
	OfferStatus.RESERVATION_CANCEL_FAILED
] as const

export const nonReservationStatuses = [
	OfferStatus.AVAILABLE,
	OfferStatus.EXPIRED_DATES,
	OfferStatus.NOT_AVAILABLE,
	OfferStatus.TRIP_COMPLETED
] as const

export const allStatuses = [...reservationStatuses, ...nonReservationStatuses]

export const showSupplierInfoInReservation = [
	// NOTE: We don't show supplier info if offer in payment

	// OfferStatus.PAYMENT_PENDING,
	// OfferStatus.PAYMENT_FAILED,
	// OfferStatus.PAYMENT_PENDING,

	// NOTE: We don't show supplier info if reservation failed or in pending(?)

	// OfferStatus.RESERVATION_PENDING,
	// OfferStatus.RESERVATION_FAILED,
	OfferStatus.RESERVED,

	// XXX: Cancelled under question

	OfferStatus.RESERVATION_CANCELLED,
	OfferStatus.RESERVATION_CANCEL_PENDING,
	OfferStatus.RESERVATION_CANCEL_FAILED
] as const

/* Fast check if we use all statuses */

type ExpectTrue<T extends true> = T
type AllStatuses = (typeof allStatuses)[number]

// @ts-expect-error @typescript-eslint/no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type Difference = ExpectTrue<
	AllStatuses | OfferStatus extends AllStatuses ? true : false
>
